import React from "react";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { useTranslation } from "react-i18next";

function KopfplatteKantenlaenge({ kantenlaenge = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.lengthWasherPlate")}</p>}
      indicesValue={<span>U</span>}
      inputValue={<span className="input">{kantenlaenge}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default KopfplatteKantenlaenge;
